import React from "react";
import { Page, BlockTitle } from "framework7-react";
import { getMobileCustomFormMenuModuleNav, MobileNavList } from "./helpers";
import SyncStatusChip from "modules/offline/SyncStatusChip";
import { resolvePendingConflictsInteractively } from "modules/offline";

const CustomFormMenuModuleSidebar = ({ menuId, custom_forms, custom_forms_menus, offline_status }) => {
  const { menuLabel, items } = getMobileCustomFormMenuModuleNav(custom_forms_menus, menuId, custom_forms);

  return (
    <Page>
      <div
        onClick={() => {
          if (offline_status?.conflictCount > 0) resolvePendingConflictsInteractively();
        }}
      >
        <SyncStatusChip />
      </div>
      <BlockTitle>{menuLabel}</BlockTitle>
      <MobileNavList items={items} />
    </Page>
  );
};

export default CustomFormMenuModuleSidebar;
